/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import IEnergyManagementProps from '../../IEnergyManagementProps';
import { Card } from '@scuf/common';
import SiteEUIHOC from './SiteEUIHOC/SiteEUIHOC';

import {
  ContextProvider,
  updateApiConfig
} from '../../../../context/ApiContext';
import { withLocalization } from '../../../../locales/withLocalization';

const SiteEUIKPI = (props: IEnergyManagementProps) => {
  const {
    connectorConfig,
    bearerToken,
    requestContext,
    emaasContext,
    preferredEuiUnit
  } = props;

  const { onSiteEnergyUsageCardClick } = emaasContext!;

  const onCardClick = () => {
    if (onSiteEnergyUsageCardClick) {
      onSiteEnergyUsageCardClick();
    }
  };

  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <DataContextProvider config={connectorConfig}>
        <Card>
          <Card.Content onClick={() => onCardClick()}>
            <SiteEUIHOC
              requestContext={requestContext}
              bearerToken={bearerToken}
              preferredEuiUnit={preferredEuiUnit || ''}
            />
          </Card.Content>
        </Card>
      </DataContextProvider>
    </ContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(SiteEUIKPI);
